const Loader = ({ color, text }) => {
  return (
    <>
      <div className="flex flex-col grow items-center justify-center bg-transparent p-5 ">
        <svg width="128" height="128" viewBox="0 0 212 212" fill={color} className="w-32 animate-spin">
          <g clipPath="url(#clip0_1204_1264)">
            <g mask="url(#mask0_1204_1264)">
              <path d="M57.1942 136.371C58.8591 139.026 58.0551 142.527 55.4007 144.192C54.4601 144.781 53.4107 145.062 52.3761 145.059C50.4942 145.054 48.6551 144.112 47.58 142.398C40.6842 131.398 37.0583 118.693 37.0942 105.654C37.199 67.6603 68.1954 36.8345 106.189 36.9392C116.897 36.9687 127.242 39.4441 136.645 44.1297L138.79 29.5986L152.079 60.9317L118.111 58.7783L128.956 53.0716C121.822 49.9605 114.113 48.3076 106.158 48.2857C74.4199 48.1982 48.5284 73.9473 48.4409 105.686C48.4109 116.578 51.4382 127.189 57.1942 136.371ZM164.547 69.4948C162.892 66.8339 159.393 66.0193 156.733 67.6728C154.072 69.3277 153.256 72.8262 154.91 75.4869C160.596 84.6265 163.586 95.1792 163.556 106.003C163.469 137.739 137.577 163.489 105.84 163.401C98.1478 163.38 90.6727 161.838 83.7287 158.919L94.2962 153.612L60.3742 150.817L73.0701 182.396L75.5308 167.654C84.8887 172.281 95.1803 174.718 105.809 174.748C143.803 174.852 174.798 144.028 174.903 106.034C174.938 93.0787 171.358 80.4442 164.547 69.4948Z" fill={color} />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_1204_1264">
              <rect width="212" height="212" fill={color} />
            </clipPath>
          </defs>
        </svg>
        {text &&
          <p className={`text-2xl text-pink mt-5 font-semibold text-center`}>
            {text}
          </p>
        }
      </div>
    </>
  )
}

export default Loader
